import { Link } from "react-router-dom";
import { Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useRemoveAccessMutation } from "@/redux/apis/client/clientApi";
import { addToast } from "@/utils";
import { useClientsContext } from "../context";
import { getManageAccountPath } from "../helpers";
import { ClientsConfirmStep } from "./ClientsConfirmStep";

interface ClientsRemoveAccessProps {
  onClose: () => void;
}

export const ClientsRemoveAccess = ({ onClose }: ClientsRemoveAccessProps) => {
  const { selectedClient } = useClientsContext();
  const [removeAccess, { isLoading }] = useRemoveAccessMutation();

  const onConfirm = () => {
    if (!selectedClient) return;

    removeAccess(selectedClient.id)
      .unwrap()
      .then(() => {
        addToast("success", `Removed access for ${selectedClient.name}`);
        onClose();
      })
      .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
  };

  return (
    <ClientsConfirmStep title="Remove Access" confirmLabel="Remove" danger isLoading={isLoading} onConfirm={onConfirm} onClose={onClose}>
      <Typography variant="paragraph">
        Are you sure you want to remove{" "}
        {selectedClient && (
          <Link to={getManageAccountPath(selectedClient.id)} className="inline-flex hover:text-info" target="_blank">
            {`${selectedClient.name}'s`}
          </Link>
        )}{" "}
        Access from RideMinder?
      </Typography>
    </ClientsConfirmStep>
  );
};
